import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NewsletterFormContainer from "../features/Newsletter/NewsletterFormContainer";

const AppNewsletter: React.FC = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/:locale" element={<NewsletterFormContainer/>} />
            </Routes>
        </BrowserRouter>
    );
};

export default AppNewsletter;
